<template>
  <div class="min-h-screen flex items-center justify-center">
    <div class="text-center">
      <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500 mx-auto"></div>
      <p class="mt-4 text-gray-600">{{ $t('auth.callback.completing') }}</p>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuth } from '../composables/useAuth'

const router = useRouter()
const { setTokens, fetchCurrentUser } = useAuth()

onMounted(async () => {
  try {
    // Extract tokens from URL parameters
    const params = new URLSearchParams(window.location.search)
    const access = params.get('access')
    const refresh = params.get('refresh')

    if (!access || !refresh) {
      // No tokens in URL, redirect to login
      router.push('/login')
      return
    }

    // Store tokens
    setTokens(access, refresh)

    // Fetch user data
    const result = await fetchCurrentUser()

    if (result.success) {
      router.push('/lists')
    } else {
      router.push('/login')
    }
  } catch (error) {
    console.error('Error during OAuth callback:', error)
    router.push('/login')
  }
})
</script>
